import { Component } from "react";

import NotificationHandler from "@app/NotificationHandler";
import { NotificationContext } from "@app/notifications/NotificationContext";

class NotificationHandlerWrapper extends Component<{ children?: React.ReactNode; } & unknown> {

  public render() {
    return (
      <NotificationContext.Consumer>
        {(notificationProps) => (<NotificationHandler subscribe={notificationProps.subscribe} unsubscribe={notificationProps.unsubscribe}>{this.props.children}</NotificationHandler>)}
      </NotificationContext.Consumer>
    );
  }

}

export default NotificationHandlerWrapper;
